import React from "react";
import { Table, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import { renderOrderStatus, renderOrderSide } from "../../../Order/Item";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import translate from "../../../../utils/Translator";
import style from "./Grid.module.scss";

const Grid = ({ data, loading, Link }) => {
  return (
    <div className={style.grid}>
      <Table id="funds-report-table" className={style.table} striped>
        <thead>
          <tr>
            <th>Fund Ticker</th>
            <th>Order Fund</th>
            <th>Process Date</th>
            <th>Settlment Date</th>
            <th>Description</th>
            <th>{translate("Account")} Name Fund</th>
            <th>{translate("Account")} Number Fund</th>
            <th>{translate("Account")} Number CSBA</th>
            <th>Status Funds</th>
            <th>Status CSBA</th>
            <th>Order CSBA</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <EmptyTable loading={true} />
          ) : !data || data.length == 0 ? (
            <EmptyTable />
          ) : (
            data.map((d, i) => (
              <tr key={`c-${d.Funds.ParentOrderId}`}>
                <td>{d.Funds.ParentOrderAssetTicker}</td>
                <td>{d.Funds.ParentOrderId}</td>
                <td>{d.Funds.ParentOrderProcessDate}</td>
                <td>{d.Funds.ParentOrderSettlementDate}</td>
                <td>
                  {renderOrderSide({ OrderSide: d.Funds.ParentOrderSide })}{" "}
                  <span className={style.bold}>
                    <FormattedNumber value={d.Funds.AccountOrderQuantity} dataTypeDecimalName="quantity" />
                  </span>
                  <span className={style.bold}>
                    {d.Funds.ParentOrderQuantityIsCash ? "(Cash)" : "(Shares)"}
                  </span>
                  <span className={style.bold}>
                    {d.Funds.AccountOrderIsFullLiquidation ? " Full liq" : ""}
                  </span>
                </td>
                <td className={style.accountNameCell} title={d.Funds.AccountOrderAccountName}>
                  {d.Funds.AccountOrderAccountName}
                </td>
                <td>{d.Funds.AccountOrderAccountNumber}</td>
                <td>{d.CSBA && d.CSBA.AccountOrderAccountNumber}</td>
                <td>{renderOrderStatus({ OrderStatus: d.Funds.OrderStatus })}</td>
                <td>{renderOrderStatus({ OrderStatus: d.CSBA ? d.CSBA.OrderStatus : "" })}</td>
                <td>{d.CSBA && d.CSBA.ParentOrderId}</td>
                <td>
                  <Actions d={d} Link={Link} />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

const Actions = ({ d, Link }) => {
  return !d.CSBA ? null : (
    <div className={style.actions}>
      <UncontrolledDropdown>
        <DropdownToggle color="link" size="lg" className={style.dropdown}>
          <i className="icon-options-vertical icons d-block" />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            tag={Link}
            to={`/crossReference/Order/${d.CSBA.ParentOrderId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Go To Cross Reference
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

const EmptyTable = ({ loading }) => (
  <tr>
    <td colSpan="12" className={style.empty}>
      {loading ? (
        <CircularProgress style={{ marginTop: "10%" }} />
      ) : (
        <h4 style={{ textAlign: "center" }}>No values</h4>
      )}
    </td>
  </tr>
);

export default Grid;
